
const contents = "query NetworkTopicSettingsClients {\n  settings {\n    network {\n      ...NetworkTopicSettingsFields\n    }\n    copilot {\n      viewerCanAccessAIAssistedAnswers\n    }\n  }\n}\n\nfragment NetworkTopicSettingsFields on NetworkSettings {\n  isOfficeTopicsEnabled\n  networkTopicsState\n}\n";
const sha256Hash = "0b1c005373f93894402d5834cba9a3b9997807d99a607d01d2d57283c760528d";
export default { contents: contents, sha256Hash: sha256Hash };
